import React from 'react'
import PropTypes from 'prop-types'
import './styles.scss'
import deletedIcon from 'assets/shop/deleted.png'

function FilterView({ filter, onClearFilter }) {
  const selectedFilters = []

  if (filter.price && filter.price.length > 0) {
    selectedFilters.push({
      category: 'Price',
      display: filter.price[0].display
    })
  }

  if (filter.type && filter.type.length > 0) {
    selectedFilters.push({
      category: 'Type',
      display: filter.type[0].type
    })
  }

  if (filter.size && filter.size.length > 0) {
    selectedFilters.push({
      category: 'Size',
      display: `${filter.size[0].size}`
    })
  }

  if (filter.color && filter.color.length > 0) {
    selectedFilters.push({
      category: 'Color',
      display: filter.color[0].color
    })
  }

  return (
    <div className="selected-filters">
      {selectedFilters.length > 0 && <p>You choose</p>}
      <div className="main-tag-filter">
        {selectedFilters.map((filterItem, index) => (
          <div
            key={index}
            className={`selected-filter ${
              filterItem.category === 'Price' ? 'selected-filter-price' : ''
            } ${filterItem.category === 'Type' ? 'selected-filter-type' : ''} ${
              filterItem.category === 'Size' ? 'selected-filter-size' : ''
            } ${filterItem.category === 'Color' ? 'selected-filter-color' : ''}`}
          >
            <img onClick={() => onClearFilter(filterItem.category)} src={deletedIcon} alt="" />
            {filterItem.category === 'Size' ? (
              <p>Size {filterItem.display.toUpperCase()}</p>
            ) : (
              <p>{filterItem.display.charAt(0).toUpperCase() + filterItem.display.slice(1)}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

FilterView.propTypes = {
  filter: PropTypes.object,
  onClearFilter: PropTypes.func
}

export default FilterView
